const userRouter = [
  {
    path: 'moneyBack',
    name: 'moneyBack',
    component: () => import('@/views/wxapp/customer-manager/userBack/moneyBack'),
    meta: {
      title: '退款用户'
    }
  }
]
export default userRouter
